import i18n from 'i18next';
import { BannerJourneyType } from '../redux/content/content.duck.interface';

// webpack will replace process.env.ENV_VAR in build time if ENV_VAR is set to some value
// this mainly just saves space by shaving off unused envs but causes problems with runtime load of environments by MM
// so environment local var can be used to prevent that, with small cost to size
const environment = JSON.parse(JSON.stringify(process.env));

export type BRAND_TYPE = 'AC' | 'AP' | 'DS' | 'OV' | undefined;
export const BRAND_AP: BRAND_TYPE = 'AP';
export const BRAND_AC: BRAND_TYPE = 'AC';
export const BRAND_DS: BRAND_TYPE = 'DS';
export const BRAND_OV: BRAND_TYPE = 'OV';
export const BRAND: BRAND_TYPE = environment.NEXT_PUBLIC_BRAND as BRAND_TYPE;
export const isBrand = (type: BRAND_TYPE): boolean => BRAND === type;
export const isBrandAP = isBrand(BRAND_AP);
export const isBrandAC = isBrand(BRAND_AC);
export const isBrandDS = isBrand(BRAND_DS);
export const isBrandOV = isBrand(BRAND_OV);

export const PRINT_DATEFORMAT_ERRORS = environment.NPM_CONFIG_DATELOG || false;
export const PRINT_MEMORY_USAGE = environment.NPM_CONFIG_MEMLOG || false;
export const PRINT_PX_ERROR = environment.NPM_CONFIG_PXLOG || false;

export const STATIC_ASSET_BASE_URL = environment.STATIC_ASSET_BASE_URL || '/public';
export const MARKET = environment.NEXT_PUBLIC_MARKET;

export const LANGUAGE = environment.NEXT_PUBLIC_LANGUAGE;

export const BACKEND_URL = `${environment.NEXT_PUBLIC_API_URL}/spc-api/api/v1`;
export const BACKEND_DEEPLINK_REDIRECT_URL = `${environment.NEXT_PUBLIC_API_URL}/spc-api/redirect`;

export const CDN_HOST_URL = environment.NEXT_PUBLIC_CDN_HOST;
export const CDN_ENABLED = environment.NEXT_PUBLIC_CDN_ENABLED;

export const SESSION_COOKIE_NAME = environment.NEXT_PUBLIC_SESSION_COOKIE_NAME;
export const SESSION_DOMAIN = environment.NEXT_PUBLIC_SESSION_DOMAIN;
export const SESSION_LIFETIME = environment.NEXT_PUBLIC_SESSION_LIFETIME;
export const SESSION_REQUEST_HEADER_NAME = environment.NEXT_PUBLIC_SESSION_REQUEST_HEADER_NAME;

export const PX_AUTH_HEADER_SECRET = environment.NEXT_PUBLIC_PX_AUTH_HEADER_SECRET;
export const PX_BACKEND_URL = environment.NEXT_PUBLIC_PX_BACKEND_URL;

export const MY_ACCOUNT_URL = environment.NEXT_PUBLIC_MY_ACCOUNT_URL;

export const FINANCE_SIMULATION_BASE_URL = environment.NEXT_PUBLIC_FINANCE_SIMULATION_BASE_URL;
export const FINANCE_SIMULATION_CLIENT_ID = environment.NEXT_PUBLIC_FINANCE_SIMULATION_CLIENT_ID;

export const MOP_ID_COOKIE_NAME = 'MOP_ID';
export const MOP_CAR_CONFIGURATION_COOKIE_NAME = 'MOP_CAR_CONFIGURATION';
export const MOP_JOURNEY_COOKIE_NAME = 'MOP_JOURNEY';

export const DIGITAL_URL = environment.NEXT_PUBLIC_DIGITAL_URL;
export const LEAD_FORM_ID = environment.NEXT_PUBLIC_LEAD_FORM_ID;

export const DEFAULT_BANNER_JOURNEY_TYPE = environment.NEXT_PUBLIC_DEFAULT_BANNER_JOURNEY_TYPE as BannerJourneyType;

export const NEXT_PUBLIC_API_URL = environment.NEXT_PUBLIC_API_URL;
export const NEXT_PUBLIC_APP_PREFIX = environment.NEXT_PUBLIC_APP_PREFIX;

export const DYNAMIC_YIELD_API_TOKEN = environment.NEXT_PUBLIC_DYNAMIC_YIELD_API_TOKEN;

export const IS_CLIENT = typeof window !== 'undefined';
export const IS_SERVER = !IS_CLIENT;

export const IS_DEV = environment.NODE_ENV === 'development';

export const FAQ_URL_STRING = 'faqs';
export const STOCK_TRIMS_PER_PAGE = 9;

export const CARTE_GRISE_FEE = 'carte_grise';
export const MALUS_FEE = 'malus';

export const CHECKOUT_CASH_URL = environment.NEXT_PUBLIC_CHECKOUT_URL_CASH;
export const CHECKOUT_FINANCE_URL = environment.NEXT_PUBLIC_CHECKOUT_URL_FINANCE;

export const FINANCE_WIDGET_CONTEXT_COLOUR = environment.NEXT_PUBLIC_FINANCE_WIDGET_CONTEXT_COLOUR;

export enum ROLES {
    IMG = 'img',
    BUTTON = 'button',
    LINK = 'link',
    LOGO = 'logo',
}

export enum MARKETS {
    FR = 'fr',
    GB = 'gb',
    ES = 'es',
    IT = 'it',
    DE = 'de',
    BE = 'be',
}

export enum LANGUAGES {
    FR = 'fr',
    EN = 'en',
    ES = 'es',
    IT = 'it',
    DE = 'de',
    NL = 'nl',
}

export enum BASKET_STEPS {
    DEFAULT = -1,
    PAYMENT = 1,
    PX = 2,
}

export enum DATE_FORMAT {
    FR = 'dd/MM/yyyy',
    EN = 'dd-MM-yyyy',
}

export enum FUEL_TYPES {
    DIESEL = 'diesel;turbo diesel;diésel;diesel hdi',
    BENZIN = 'essence;petrol;gasolina;benzina;benzin;injection essence',
    HYBRID = 'hybride-essence;petrol-hybrid;híbrido-enchufable;plug-in hybrid;phev-benzin;hybrid / benzin;híbrido gasolina',
    ELECTRIC = 'electric;eléctrico;elettrico;elektro',
}

export enum ENVIRONMENT_TYPE {
    B2B = 'ec41_b2b',
    B2C = 'default',
}

export const OFFER_DEALER_DISCOUNT_TYPE = 'extra_dealer_discount';
export const OFFER_COMMENT_TYPE = 'offer_comment';

export enum DEAL_PRODUCT_TYPE {
    PARENT = 'parent',
    CHILD = 'child',
}

export const GOOGLE_MAP_API_KEY = environment.NEXT_PUBLIC_GOOGLE_MAP_API_KEY;
export const GOOGLE_MAP_DEFAULT_LAT = environment.NEXT_PUBLIC_GOOGLE_MAP_DEFAULT_LAT;
export const GOOGLE_MAP_DEFAULT_LNG = environment.NEXT_PUBLIC_GOOGLE_MAP_DEFAULT_LNG;
export const GOOGLE_MAP_DEFAULT_ZOOM = environment.NEXT_PUBLIC_GOOGLE_MAP_DEFAULT_ZOOM;
export const GOOGLE_MAP_MAX_ZOOM = environment.NEXT_PUBLIC_GOOGLE_MAP_MAX_ZOOM;
export const GOOGLE_MAP_SEARCH_LIMIT = environment.NEXT_PUBLIC_GOOGLE_MAP_SEARCH_LIMIT;
export const GOOGLE_RESTRICTED_COUNTRY = environment.NEXT_PUBLIC_GOOGLE_RESTRICTED_COUNTRY;

export const DEFAULT_DISTANCE_OPTIONS_STEP = parseInt(environment.NEXT_PUBLIC_DEFAULT_DISTANCE_OPTIONS_STEP);
export const DISTANCE_OPTIONS = environment.NEXT_PUBLIC_DISTANCE_OPTIONS;

export const B2B_BRANDID_REGISTER_URL_SUFFIX = environment.NEXT_PUBLIC_B2B_BRANDID_REGISTER_URL_SUFFIX;
export const B2B_URL = environment.NEXT_PUBLIC_URL_B2B;
export const B2C_URL = environment.NEXT_PUBLIC_URL_B2C;
export const CONTEXT = environment.NEXT_PUBLIC_CONTEXT ?? ENVIRONMENT_TYPE.B2C;

export const IS_B2B = CONTEXT === ENVIRONMENT_TYPE.B2B;
export const IS_B2C = CONTEXT === ENVIRONMENT_TYPE.B2C;

export const ParametrizedPathRegExp = /\?(.*)/;

export const NON_BREAKING_SPACE = '\xa0';

export const FEATURE_SWITCHES_COOKIE_NAME = 'FEATURE_SWITCHES';

export const IS_IMPERIAL_MEASUREMENT_SYSTEM = [MARKETS.GB].includes(MARKET as MARKETS);

export const MM_HEADERS = {
    'x-language': i18n.language ?? environment.NEXT_PUBLIC_LANGUAGE,
    'x-market': environment.NEXT_PUBLIC_MARKET,
    'x-context': CONTEXT,
    'x-brand-code': environment.NEXT_PUBLIC_BRAND,
    'x-env-name': environment.NEXT_PUBLIC_ENV_NAME,
};

export const MULTI_LANGUAGES = environment.NEXT_PUBLIC_FEATURE_SWITCH_ALLOWED_LANGUAGES?.split(';') || [];
export const MULTI_LANGUAGES_ENABLED = MULTI_LANGUAGES.length > 0;

export const BR_DISABLE_PAGE_REDIRECT_URL = environment.NEXT_PUBLIC_BR_DISABLE_PAGE_REDIRECT_URL;

export const STOCK_REDICT_URL_FROM_CONFIG_PAGE = environment.NEXT_PUBLIC_STOCK_REDICT_URL_FROM_CONFIG_PAGE;

export const PROMO_CODE_KEY = `PROMO_CODE_${BRAND}_${MARKET}_${LANGUAGE}`;
// if u are planning to change LANGUAGE_KEY please change the format in server.js too (getLanguageCookie)
export const LANGUAGE_KEY = `LANGUAGE_${MARKET}_${environment.NEXT_PUBLIC_ENV_NAME}_${BRAND}`;

export const isMarketGB = MARKET === MARKETS.GB;
export const isMarketES = MARKET === MARKETS.ES;
export const isMarketIT = MARKET === MARKETS.IT;
export const isMarketDE = MARKET === MARKETS.DE;
export const isMarketFR = MARKET === MARKETS.FR;
export const isMarketBE = MARKET === MARKETS.BE;

export const isVauxhall = isBrand(BRAND_OV) && isMarketGB;

export enum FUEL_KEYS {
    ESSENCE = 'Essence',
    DIESEL = 'Diesel',
    HYBRIDE_ESSENCE = 'Hybride-Essence',
    ELECTRIQUE = 'Electrique',
    // SOL UK fuel names
    ELECTRIC = 'Electric',
    PETROL = 'Petrol',
    TURBO_DIESEL = 'Turbo Diesel',
    PETROL_HYBRID = 'Petrol-Hybrid',
    // ES
    DIESEL_ES = 'Diésel',
    PETROL_ES = 'Gasolina',
    ELECTRIC_ES = 'Eléctrico',
    PETROL_HYBRID_ES = 'Híbrido-Enchufable',
    // IT
    PETROL_IT = 'Benzina',
    ELECTRIC_IT = 'Elettrico',
    DIESEL_HDI = 'Diesel HDi',
    PLUG_IN_HYBRID = 'Plug-in Hybrid',
    // DE
    PETROL_DE = 'Benzin',
    PHEV_BENZIN = 'PHEV-Benzin',
    PETROL_HYBRID_DE = 'Hybrid / Benzin',
    ELECTRIC_DE = 'Elektro',
}

export enum FILTER_CATEGORY {
    BUDGET = 'budget',
    FUEL = 'fuel',
    GEARBOX = 'gearbox',
    PAYMENT_JOURNEY_TYPE = 'paymentJourneyType',
    PRICES = 'prices',
    ENERGIES = 'energies',
    GEARBOX_TYPES = 'gearboxTypes',
    GRADES = 'grades',
    ENGINES = 'engines',
    COLOR_GROUPS = 'colorGroups',
    BODY_STYLES = 'bodyStyles',
    TRANSMISSION_TYPES = 'transmissionTypes',
    FINITION = 'finition',
    MOTORIZATION = 'motorization',
    COLOR = 'color',
}

export enum CURRENCY {
    EUR = '€',
}

export enum FINANCE_DETAIL_VIEW {
    LINK = 'link',
    ICON = 'icon',
    HIDDEN = 'hidden',
}

export const config = {
    BRAND,
    MARKET,
    LANGUAGE,
    BACKEND_URL,
};

export const RANGE_STEP = 100;
